import React from "react";

const Progress = ({ checkoutState, setCheckoutState }) => {
  const steps = [
    {
      label: "Contact Information",
      states: ["userdetails", "authentication"],
      number: 1,
    },
    { label: "Delivery Mode", states: ["delivery"], number: 2 },
    { label: "Checkout", states: ["processed"], number: 3 },
  ];

  // Find the index of the current step
  const currentStepIndex = steps.findIndex((step) =>
    step.states.includes(checkoutState)
  );

  return (
    <div className="progress-container">
      {steps.map((step, index) => {
        const isCurrentOrPassed = index <= currentStepIndex;
        const isClickable = index <= currentStepIndex;

        return (
          <button
            key={index}
            type="button"
            onClick={() => {
              if (isClickable) setCheckoutState(step.states[0]);
            }}
            disabled={!isClickable}
            className={`progress-step ${isCurrentOrPassed ? "active" : ""} ${
              !isClickable ? "disabled" : ""
            }`}
          >
            <div className="step-circle">{step.number}</div>
            <div className="step-label">{step.label}</div>
          </button>
        );
      })}
    </div>
  );
};

export default Progress;
